export function GetInternalAuthCallbackUrl() {
  try {
    if (document.location.href.indexOf('internalAuthCallbackUrl') > -1) {
      return decodeURIComponent(document.location.href.split('internalAuthCallbackUrl=')[1]);
    }
  } catch {}
  return '';
}
